import { render } from "./IdentifierUpdate.vue?vue&type=template&id=3ef54ea0"
import script from "./IdentifierUpdate.vue?vue&type=script&lang=js"
export * from "./IdentifierUpdate.vue?vue&type=script&lang=js"

import exportComponent from "/trc/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__